import type {BioIconProps} from '../common-types'

export function GraphIcon({fill = '#FF9900', ...attributes}: BioIconProps) {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
      <path d="M20.75 20.75H0.75" stroke="#FF9900" strokeWidth="1.5" strokeLinecap="round" />
      <path
        d="M19.75 20.75V13.25C19.75 12.8522 19.592 12.4706 19.3107 12.1893C19.0294 11.908 18.6478 11.75 18.25 11.75H15.25C14.8522 11.75 14.4706 11.908 14.1893 12.1893C13.908 12.4706 13.75 12.8522 13.75 13.25V20.75V3.75C13.75 2.336 13.75 1.629 13.31 1.19C12.872 0.75 12.165 0.75 10.75 0.75C9.335 0.75 8.629 0.75 8.19 1.19C7.75 1.628 7.75 2.335 7.75 3.75V20.75V8.25C7.75 7.85218 7.59196 7.47064 7.31066 7.18934C7.02936 6.90804 6.64782 6.75 6.25 6.75H3.25C2.85218 6.75 2.47064 6.90804 2.18934 7.18934C1.90804 7.47064 1.75 7.85218 1.75 8.25V20.75"
        stroke={fill}
        strokeWidth="1.5"
      />
    </svg>
  )
}
